// assets/curator-templates.js
(function () {
  const form = document.getElementById('ctg-form');
  if (!form) return;

  // --- EXISTING refs ---
  const nameInput = document.getElementById('ctg-name');
  const codeInput = document.getElementById('ctg-code');
  const errorEl   = document.getElementById('ctg-error');
  const outputEl  = document.getElementById('ctg-output');

  // Subject (contenteditable)
  const subjectEditor  = document.getElementById('ctg-subject-editor');
  const copySubjectBtn = document.getElementById('ctg-copy-subject');
  const copySubjectStatus = document.getElementById('ctg-copy-subject-status');

  // Email body + actions
  const previewEl = document.getElementById('ctg-email-preview');
  const emailActions = document.getElementById('ctg-email-actions');
  const rawArea   = document.getElementById('ctg-email-raw');
  const copyBtn   = document.getElementById('ctg-copy');
  const copyStatus = document.getElementById('ctg-copy-status');

  // Titles (for toggling)
  const subjectTitle = document.getElementById('ctg-subject-title');
  const subjectRow   = document.getElementById('ctg-subject-row');
  const bodyTitle    = document.getElementById('ctg-body-title');

  // QR block
  const qrOutput   = document.getElementById('ctg-qr-output');
  const qrCanvas   = document.getElementById('ctg-qr-canvas');
  const qrImg      = document.getElementById('ctg-qr-img');
  const qrDownload = document.getElementById('ctg-qr-download');
  const qrStatus   = document.getElementById('ctg-qr-status');


  // Headings and button label we need to rewrite per template
  const titleH2     = outputEl ? outputEl.querySelector('.ctg-subtitle')    : null;
  const subtitleH4  = outputEl ? outputEl.querySelector('.ctg-subtitle-h4') : null;
  const bodyTitleEl = document.getElementById('ctg-body-title');
  const copyBtnEl   = document.getElementById('ctg-copy');

  // Capture current/default labels so we can restore them
  const BASE_LABELS = {
    h2:  titleH2    ? titleH2.textContent.trim()    : 'Personalized Template',
    h4:  subtitleH4 ? subtitleH4.textContent.trim() : 'to send to your audience',
    body: bodyTitleEl ? bodyTitleEl.textContent.trim() : 'Email body:',
    copy: copyBtnEl ? copyBtnEl.textContent.trim()  : 'Copy email body text'
  };


  //label switcher
  function applyLabelsForTemplate(key) {
    if (titleH2 && subtitleH4) {
      if (key === 'social_post') {
        titleH2.textContent    = 'Your Social Media Post';
        subtitleH4.textContent = 'This is a sample text. Feel free to customize it, add images or your QR code from the dropdown above';
      } else if (key === 'qr_code') {
        titleH2.textContent    = 'Personalized QR Code';
        subtitleH4.textContent = 'to show to your audience';
      } else {
        // restore defaults for all other email templates
        titleH2.textContent    = BASE_LABELS.h2;
        subtitleH4.textContent = BASE_LABELS.h4;
      }
    }

    // Body title and copy button only change for social_post
    if (bodyTitleEl) {
      bodyTitleEl.textContent = (key === 'social_post')
        ? 'Post text:'
        : BASE_LABELS.body;
    }
    if (copyBtnEl) {
      copyBtnEl.textContent = (key === 'social_post')
        ? 'Copy the text'
        : BASE_LABELS.copy;
    }
  }

  // ---------- CE GUARD: never allow truly-empty contenteditable ----------
  function setPlaceholder(el, placeholder) {
    if (!el) return;
    el.setAttribute('data-placeholder', placeholder || '');
    ensureNotEmpty(el);
    el.addEventListener('input', () => {
      if ((el.textContent || '').trim() === '') {
        el.classList.add('is-empty');
        ensureNotEmpty(el);
      } else {
        el.classList.remove('is-empty');
        el.querySelectorAll('[data-ctg-placeholder]').forEach(n => n.remove());
      }
    });
    el.addEventListener('paste', () => {
      el.classList.remove('is-empty');
      el.querySelectorAll('[data-ctg-placeholder]').forEach(n => n.remove());
    });
    el.addEventListener('focus', () => {
      if ((el.textContent || '').trim() === '') {
        el.classList.add('is-empty');
        ensureNotEmpty(el);
      }
    });
    el.addEventListener('blur', () => {
      if ((el.textContent || '').trim() === '') {
        el.classList.add('is-empty');
        ensureNotEmpty(el);
      }
    });
  }

  function ensureNotEmpty(el) {
    const html = (el.innerHTML || '').replace(/\s|&nbsp;/g, '');
    if (!html || html === '<br>' || html === '<div><br></div>') {
      el.innerHTML = '<br data-ctg-placeholder="1">';
    }
  }

  function getCleanEditableHtml(el) {
    const clone = el.cloneNode(true);
    clone.querySelectorAll('[data-ctg-placeholder]').forEach(n => n.remove());
    return clone.innerHTML.trim();
  }

  // Apply guard to any CE editors that exist on the page
  setPlaceholder(previewEl, 'Write or edit your email here…');
  setPlaceholder(subjectEditor, 'Type your subject here…');

  // ---------- Helpers ----------
  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, s => ({
      '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'
    }[s]));
  }

  function normalizeCode(raw) {
    const t = (raw || '').trim();
    if (!t) return t;
    try {
      const u = new URL(t);
      const parts = u.pathname.split('/').filter(Boolean);
      return parts.pop() || t;
    } catch {
      const parts = t.split('/').filter(Boolean);
      return parts.pop() || t;
    }
  }
  function htmlToPlain(html) {
    const container = document.createElement('div');
    container.innerHTML = html;
    container.querySelectorAll('a').forEach(a => {
      a.insertAdjacentText('afterend', ` (${a.href})`);
    });
    return container.innerText;
  }

  // ---------- Base email body (your current template) ----------
  function baseEmailHtml(name, curatorCode) {
    const safeName = escapeHtml(name);
    const encodedCode = encodeURIComponent(curatorCode);
    const ctaStyle = 'display:inline-block;background:#b90000;color:#fff;padding:10px 14px;border-radius:6px;text-decoration:none;font-weight:600';

    return `
      <p>Hello,</p>

      <p>As a proud backer of <strong><em>I Know Catherine, the Log Lady</em></strong>, I am sending you a special discount link because I believe we should all see this film. It is about love, friendship, <em>Twin Peaks</em> and life. It stars <strong>David Lynch, Catherine Coulson, Kyle MacLachlan</strong> and more.</p>

      <p><a class="ctg-cta" style="${ctaStyle}" href="https://joma.film/films/i-know-catherine/${encodedCode}">Watch the film with a discount!</a></p>

      <p>Watching this movie can help us all open a dialogue about dying and living a deeper, more meaningful life.</p>

      <p><a href="https://iknowcatherine.com/pages/for-invited-curators-why-watch-i-know-catherine">Why watch the film?</a></p>

      <p>Life gives more than death can take away and <em>I Know Catherine, The Log Lady</em> delivers powerful inspiration for living every moment in the fullest possible way.</p>

      <p><a href="https://iknowcatherine.com/pages/trailer">Watch trailer</a></p>

      <p>I'd love to hear your thoughts.<br><br>
      Best,<br>
      ${safeName}</p>
    `.trim();
  }

  function buildTemplateOriginalBackersHtml(name, code) { return baseEmailHtml(name, code); }
  function buildTemplateFriendsFamilyHtml(name, code)  { 
    const safeName = escapeHtml(name);
    const encodedCode = encodeURIComponent(code);
    const ctaStyle = 'display:inline-block;background:#b90000;color:#fff;padding:10px 14px;border-radius:6px;text-decoration:none;font-weight:600';

    return `
      <p>Hello,</p>
      <p><strong><em>I Know Catherine, the Log Lady</em></strong> moved me so much I became a curator. I am sending you a special discount link to watch it for $5 off because I believe you will be moved by it too.</p>
      <p>Catherine Coulson became a cult icon as the Log Lady in the groundbreaking TV series <em>Twin Peaks</em>. The film tells the story of her extraordinary life and inspiring death. It stars <strong>David Lynch, Catherine Coulson, Kyle MacLachlan</strong> and more.</p>

      <p><a class="ctg-cta" style="${ctaStyle}" href="https://joma.film/films/i-know-catherine/${encodedCode}">Watch the film with a discount!</a></p>

      <p>Watching this movie can help us all open a dialogue about dying and living a deeper, more meaningful life.</p>

      <p><a href="https://iknowcatherine.com/pages/for-invited-curators-why-watch-i-know-catherine">Why watch the film?</a></p>

      <p>Life gives more than death can take away and <em>I Know Catherine, The Log Lady</em> delivers powerful inspiration for living every moment in the fullest possible way.</p>

      <p><a href="https://iknowcatherine.com/pages/trailer">Watch trailer</a></p>

      <p>I’d love to hear your thoughts.<br><br>
      Best,<br>
      ${safeName}</p>
      `.trim();
  }
  function buildTemplateNewCuratorsHtml(name, code)    { 
    const safeName = escapeHtml(name);
    const encodedCode = encodeURIComponent(code);
    const ctaStyle = 'display:inline-block;background:#b90000;color:#fff;padding:10px 14px;border-radius:6px;text-decoration:none;font-weight:600';

    return `
      <p>Hello,</p>
      <p><strong><em>I Know Catherine, the Log Lady</em></strong> moved me so much I became a curator. I am sending you a special discount link to watch it for $5 off because I believe you will be moved by it too.</p>
      <p>Catherine Coulson became a cult icon as the Log Lady in the groundbreaking TV series <em>Twin Peaks</em>. The film tells the story of her extraordinary life and inspiring death. It stars <strong>David Lynch, Catherine Coulson, Kyle MacLachlan</strong> and more.</p>

      <p><a class="ctg-cta" style="${ctaStyle}" href="https://joma.film/films/i-know-catherine/${encodedCode}">Watch the film with a discount!</a></p>

      <p>Watching this movie can help us all open a dialogue about dying and living a deeper, more meaningful life.</p>

      <p><a href="https://iknowcatherine.com/pages/for-invited-curators-why-watch-i-know-catherine">Why watch the film?</a></p>

      <p>Life gives more than death can take away and <em>I Know Catherine, The Log Lady</em> delivers powerful inspiration for living every moment in the fullest possible way.</p>

      <p><a href="https://iknowcatherine.com/pages/trailer">Watch trailer</a></p>

      <p>I’d love to hear your thoughts.<br><br>
      Best,<br>
      ${safeName}</p>
      `.trim();
   }
  function buildTemplateTheatreHtml(name, code)        { 
    
    const safeName = escapeHtml(name);
    const encodedCode = encodeURIComponent(code);
    const ctaStyle = 'display:inline-block;background:#b90000;color:#fff;padding:10px 14px;border-radius:6px;text-decoration:none;font-weight:600';

    return `
      <p>Hello,</p>

      <p>As someone who cares passionately about theatre, I am sending you a special discount link to watch <strong><em>I Know Catherine, the Log Lady</em></strong> because I believe everyone needs to see this film.</p>
      <p>Catherine Coulson was a theatre actress who became a cult icon as the Log Lady in the groundbreaking TV series, <em>Twin Peaks</em>. She died days after filming the death of her famous character. She got her last wish. The Show Must Go On!</p>
      <p>The film tells the story of her extraordinary life and inspiring death. It stars <strong>David Lynch, Catherine Coulson, Kyle MacLachlan, Lisa Loomer, Robert Schenkkan</strong> and more.</p>

      <p><a class="ctg-cta" style="${ctaStyle}" href="https://joma.film/films/i-know-catherine/${encodedCode}">Watch the film with a discount!</a></p>

      <p>Watching this movie will help raise funds for our current and future theatrical productions. <strong>We get $5 every time our discount code link is used.</strong></p>

      <p><a href="https://iknowcatherine.com/pages/why-watch-i-know-catherine">Why watch the film?</a></p>

      <p>Life gives more than death can take away and <em>I Know Catherine, The Log Lady</em> delivers powerful inspiration for living every moment in the fullest possible way.</p>

      <p><a href="https://iknowcatherine.com/pages/trailer">Watch trailer</a></p>

      <p>I’d love to hear your thoughts.<br><br>
      Best,<br>
      ${safeName}</p>
    
      `.trim();
   }
  function buildTemplateHealthcareHtml(name, code)     { 

    const safeName = escapeHtml(name);
    const encodedCode = encodeURIComponent(code);
    const ctaStyle = 'display:inline-block;background:#b90000;color:#fff;padding:10px 14px;border-radius:6px;text-decoration:none;font-weight:600';

    return `
      <p>Hello,</p>

      <p>As someone who cares deeply about healthcare and end of life challenges, I am sending you a special discount to watch <strong><em>I Know Catherine, the Log Lady</em></strong> because I believe everyone needs to see this film.</p>
      <p>Catherine Coulson became a cult icon as the Log Lady in the groundbreaking TV series <em>Twin Peaks</em>. She died days after filming the death of her famous character. She got her last wish. The Show Must Go On!</p>
      <p>The film tells the story of her extraordinary life and inspiring death. It stars <strong>David Lynch, Catherine Coulson, Kyle MacLachlan</strong> and more.</p>

      <p><a class="ctg-cta" style="${ctaStyle}" href="https://joma.film/films/i-know-catherine/${encodedCode}">Watch the film with a discount!</a></p>

      <p>Watching this movie will help us raise funds for our important healthcare mission. <strong>We get $5 every time our discount code link is used.</strong></p>

      <p><a href="https://iknowcatherine.com/pages/why-watch-i-know-catherine">Why watch the film?</a></p>

      <p>Life gives more than death can take away and <em>I Know Catherine, The Log Lady</em> delivers powerful inspiration for living every moment in the fullest possible way.</p>

      <p><a href="https://iknowcatherine.com/pages/trailer">Watch trailer</a></p>

      <p>I’d love to hear your thoughts<br><br>
      Best,<br>
      ${safeName}</p>
    
      `.trim();
      
  }

  function buildTemplateSocialPostHtml(name, code)     { 
    
    const safeName = escapeHtml(name);
    const encodedCode = encodeURIComponent(code);
    const ctaStyle = 'display:inline-block;background:#b90000;color:#fff;padding:10px 14px;border-radius:6px;text-decoration:none;font-weight:600';

    return `
      I just watched this film and I loved it so much that I decided to become a curator so my friends could watch it at a $5 discount.
      <br><br>

      Watch the film here:<br>
      https://joma.film/films/i-know-catherine/${encodedCode}
      <br><br>

      Why watch the film?<br>
      https://iknowcatherine.com/pages/why-watch-i-know-catherine
      <br><br>

      `.trim();

   }


  // Add dropdown arrow
  function injectSelectArrowStyles() {
    if (document.getElementById('ctg-select-arrow-styles')) return;
    const style = document.createElement('style');
    style.id = 'ctg-select-arrow-styles';
    style.textContent = `
      .ctg-select-wrap { position: relative; display: block; }
      .ctg-select-wrap .ctg-select-icon {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        width: 24px; height: 24px;
        color: rgba(0,0,0,.55);
        pointer-events: none;
        display: inline-flex; align-items: center; justify-content: center;
      }
      .ctg-select-wrap .ctg-select-icon svg { width: 24px; height: 24px; display: block; }
      /* space for the left icon + remove native arrow for consistency */
      #ctg-template.ctg-input {
        padding-right: 36px;
        appearance: none; -webkit-appearance: none; -moz-appearance: none;
        background-image: none;
      }
    `;
    document.head.appendChild(style);
  }

  function decorateTemplateSelect(selectEl) {
    if (!selectEl) return;
    if (selectEl.closest('.ctg-select-wrap')) return; // already decorated

    injectSelectArrowStyles();

    const wrap = document.createElement('div');
    wrap.className = 'ctg-select-wrap';

    const icon = document.createElement('span');
    icon.className = 'ctg-select-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = `
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M7 10l5 5 5-5H7z"></path>
      </svg>
    `;

    // Insert wrapper before the select, then move select inside and prepend icon
    selectEl.parentNode.insertBefore(wrap, selectEl);
    wrap.appendChild(icon);
    wrap.appendChild(selectEl);
  }

  // Optional: default subject per template (edit if you want unique subjects)
  const DEFAULT_SUBJECT = 'A film that means a lot to me';

  const TEMPLATES = {
    original_backers: { label: 'from Backers - Email',    build: buildTemplateOriginalBackersHtml, subject: DEFAULT_SUBJECT },
    friends_family:   { label: 'from Friends and Family - Email', build: buildTemplateFriendsFamilyHtml,   subject: DEFAULT_SUBJECT },
    new_curators:     { label: 'from New Curators - Email',       build: buildTemplateNewCuratorsHtml,     subject: DEFAULT_SUBJECT },
    theatre:          { label: 'from Theatres - Email',           build: buildTemplateTheatreHtml,         subject: DEFAULT_SUBJECT },
    healthcare:       { label: 'from Healthcare - Email',         build: buildTemplateHealthcareHtml,      subject: DEFAULT_SUBJECT },
    social_post:      { label: 'Social Media Post',       build: buildTemplateSocialPostHtml,      hasSubject: false },
    qr_code:          { label: 'Generate Your QR Code',   hasSubject: false } // special
  };

  // ---------- Inject the "Choose a template:" dropdown into the existing form ----------
  function injectTemplateDropdown() {
    const generateBtn = document.getElementById('ctg-generate') || form.querySelector('[type="submit"]');
    if (!generateBtn) return null;

    injectSelectArrowStyles();

    const field = document.createElement('div');
    field.className = 'ctg-field';
    field.innerHTML = `
      <label class="ctg-label" for="ctg-template">Choose a template or get your QR code:</label>
      <div class="ctg-select-wrap">
        <span class="ctg-select-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 10l5 5 5-5H7z"></path>
          </svg>
        </span>
        <select id="ctg-template" name="ctg-template" class="ctg-input"></select>
      </div>
    `;
    generateBtn.parentNode.insertBefore(field, generateBtn);

    const select = field.querySelector('#ctg-template');

    // Populate options from your TEMPLATES map (as in your current script)
    Object.entries(TEMPLATES).forEach(([value, meta]) => {
      const opt = document.createElement('option');
      opt.value = value;
      opt.textContent = meta.label;
      select.appendChild(opt);
    });
    select.value = 'original_backers';

    return select;
  }

  const templateSelect = injectTemplateDropdown() || document.getElementById('ctg-template');

  // Update subject when changing template (optional convenience)
  templateSelect?.addEventListener('change', () => {
    // Clear previous render and hide output until Generate
    previewEl.innerHTML = '';
    copyStatus.textContent = '';
    if (qrImg) qrImg.src = '';
    if (qrCanvas && qrCanvas.getContext) {
      const ctx = qrCanvas.getContext('2d');
      ctx && ctx.clearRect(0, 0, qrCanvas.width, qrCanvas.height);
    }
    outputEl.hidden = true;
    toggleQrUI(false);

    const key  = templateSelect.value;
    const meta = TEMPLATES[key];

    // Apply the requested label changes
    applyLabelsForTemplate(key);

    if (key === 'qr_code') {
      toggleEmailUI(false);
      toggleSubjectUI(false);
      return;
    }

    // Email-based templates
    toggleEmailUI(true);
    const hasSubject = meta?.hasSubject !== false; // false for social_post
    toggleSubjectUI(hasSubject);

    if (hasSubject && meta?.subject && subjectEditor) {
      subjectEditor.textContent = meta.subject;
      subjectEditor.classList.remove('is-empty');
      ensureNotEmpty(subjectEditor);
    } else if (!hasSubject && subjectEditor) {
      subjectEditor.textContent = '';
      subjectEditor.classList.add('is-empty');
      ensureNotEmpty(subjectEditor);
    }
  });

  if (templateSelect) templateSelect.dispatchEvent(new Event('change'));

  // ---------- UI toggles ----------
  function toggleEmailUI(show) {
    // Only body, title, and actions — NOT the subject
    if (bodyTitle)    bodyTitle.hidden    = !show;
    if (previewEl)    previewEl.hidden    = !show;
    if (emailActions) emailActions.hidden = !show;
  }

  function toggleSubjectUI(show) {
    // Subject title + row only
    if (subjectTitle) subjectTitle.hidden = !show;
    if (subjectRow)   subjectRow.hidden   = !show;
  }

  function toggleQrUI(show, codeUrl) {
    if (!qrOutput) return;
    qrOutput.hidden = !show;
    if (!show) return;
    if (codeUrl) renderQr(codeUrl);
  }

  function clearOutput() {
    // Hide both views
    toggleQrUI(false);
    toggleEmailUI(false);
    toggleSubjectUI(false);

    // Clear previous content
    if (previewEl) previewEl.innerHTML = '';
    if (qrCanvas) { const ctx = qrCanvas.getContext?.('2d'); if (ctx) ctx.clearRect(0,0,qrCanvas.width,qrCanvas.height); }
    if (qrImg) { qrImg.removeAttribute('src'); qrImg.style.display = 'none'; }

    // Hide the whole output card
    if (outputEl) outputEl.hidden = true;
  }

  // ---------- QR generation ----------
  const FALLBACK_QR_API = (text, size=512) =>
    `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(text)}`;

  async function renderQr(text) {
    qrStatus.textContent = '';
    // Prefer client-side canvas (if QRCode lib is present)
    try {
      if (window.QRCode && typeof window.QRCode.toCanvas === 'function') {
        qrImg.style.display = 'none';
        qrCanvas.style.display = 'block';
        await new Promise((resolve, reject) => {
          window.QRCode.toCanvas(
            qrCanvas,
            text,
            { width: 512, margin: 1, color: { dark: '#000000', light: '#FFFFFF' } },
            (err) => err ? reject(err) : resolve()
          );
        });
        // Set download handler from canvas
        qrDownload.onclick = () => {
          const a = document.createElement('a');
          a.href = qrCanvas.toDataURL('image/png');
          a.download = 'curator-qr.png';
          a.click();
        };
        return;
      }
      throw new Error('QRCode lib missing');
    } catch (e) {
      // Fallback: static image API
      const src = FALLBACK_QR_API(text, 512);
      qrCanvas.style.display = 'none';
      qrImg.style.display = 'block';
      qrImg.src = src;
      qrDownload.onclick = () => {
        // Best-effort download via direct link
        const a = document.createElement('a');
        a.href = src;
        a.download = 'curator-qr.png';
        a.rel = 'noopener';
        a.target = '_blank';
        a.click();
      };
      qrStatus.textContent = ''; // leave empty unless you want to warn about external API
    }
  }

  // ---------- Generate handler ----------
  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    copyStatus.textContent = '';

    const name = (nameInput.value || '').trim();
    const code = normalizeCode(codeInput.value);
    const selectedKey = templateSelect ? templateSelect.value : 'original_backers';

    if (!name || !code) {
      errorEl.hidden = false;
      return;
    }
    errorEl.hidden = true;

    // Build once (used by the QR branch)
    const curatorUrl = `https://joma.film/films/i-know-catherine/${encodeURIComponent(code)}`;

    // ---- QR branch (keep as-is) ----
    if (selectedKey === 'qr_code') {
      applyLabelsForTemplate('qr_code');   // << labels for QR
      toggleSubjectUI(false);
      toggleEmailUI(false);
      toggleQrUI(true, curatorUrl);
      outputEl.hidden = false;
      outputEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    // ---- EMAIL BRANCH ----

    applyLabelsForTemplate(selectedKey);   // << labels for email or social post

    const meta = TEMPLATES[selectedKey] || TEMPLATES.original_backers;
    const hasSubject = meta?.hasSubject !== false;

    toggleQrUI(false);
    toggleEmailUI(true);          // body/actions only
    toggleSubjectUI(hasSubject);  // subject on/off

    // Render body
    previewEl.innerHTML = meta.build(name, code);
    outputEl.hidden = false;
    outputEl.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // Keep CE from collapsing
    if ((previewEl.textContent || '').trim() === '') {
      previewEl.classList.add('is-empty');
      ensureNotEmpty(previewEl);
    } else {
      previewEl.classList.remove('is-empty');
    }

    // Subject content
    if (hasSubject && subjectEditor && meta.subject) {
      subjectEditor.textContent = meta.subject;
      subjectEditor.classList.remove('is-empty');
      ensureNotEmpty(subjectEditor);
    } else if (!hasSubject && subjectEditor) {
      subjectEditor.textContent = '';
      subjectEditor.classList.add('is-empty');
      ensureNotEmpty(subjectEditor);
    }
    // ---- END EMAIL BRANCH ----
});

  // ---------- Copy actions ----------
  copyBtn.addEventListener('click', async function () {
    const html = getCleanEditableHtml(previewEl);
    const text = htmlToPlain(html);
    try {
      if (navigator.clipboard && window.ClipboardItem) {
        const item = new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([text], { type: 'text/plain' })
        });
        await navigator.clipboard.write([item]);
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        rawArea.value = text;
        rawArea.hidden = false;
        rawArea.focus();
        rawArea.select();
        document.execCommand('copy');
        rawArea.hidden = true;
      }
      copyStatus.textContent = 'Copied to clipboard.';
      setTimeout(() => copyStatus.textContent = '', 2500);
    } catch (err) {
      copyStatus.textContent = 'Copy failed. Select and copy manually.';
      console.error('Copy failed:', err);
    }
  });

  if (copySubjectBtn) {
    copySubjectBtn.addEventListener('click', async function () {
      const subject = (subjectEditor?.textContent || '').trim();
      if (!subject) return;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(subject);
        } else {
          rawArea.value = subject;
          rawArea.hidden = false;
          rawArea.focus();
          rawArea.select();
          document.execCommand('copy');
          rawArea.hidden = true;
        }
        copySubjectStatus.textContent = 'Subject copied.';
        setTimeout(() => copySubjectStatus.textContent = '', 2000);
      } catch (e) {
        copySubjectStatus.textContent = 'Copy failed.';
        console.error('Copy subject failed:', e);
      }
    });
  }
})();
